module.exports = __webpack_public_path__ + "img/img_bg.b19a6567.png";